module.exports = __webpack_public_path__ + "static/media/thumb-fake.3acf82e7.png";